import ScrollToTop from '@/shared/components/ScrollToTop';
import HomePage from '@/views/Home/HomePage';
import NotFoundPage from '@/views/NotFound/NotFoundPage';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import ProtectedRoute from './ProtectedRoute';
import { SearchAccount } from '@/views/SearchAccount';
import PrintAccount from '@/views/PrintAccount/PrintAccount';
import ReceiptsSummary from '@/views/ReceiptsSummary/ReceiptsSummary';
import AccountStatement from '@/views/AccountStatement/AccountStatement';


export const AppRouter = () => {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <Routes>
        <Route element={<ProtectedRoute />}>
          <Route path="/" element={<HomePage />} />
          <Route path='search_account' element={<SearchAccount />} />
          <Route path='receipts_summary' element={<ReceiptsSummary />} />
          <Route path='add_payment/:id/:name/:balance' element={<PrintAccount />} />
          <Route path='account_statement/:id/:name' element={<AccountStatement />} />

        </Route>
        <Route path="*" element={<NotFoundPage />} />
      </Routes>
    </BrowserRouter>
  );
};
